import { render, staticRenderFns } from "./RouterHolder.vue?vue&type=template&id=291a8709&scoped=true"
import script from "./RouterHolder.vue?vue&type=script&lang=ts"
export * from "./RouterHolder.vue?vue&type=script&lang=ts"
import style0 from "./RouterHolder.vue?vue&type=style&index=0&id=291a8709&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291a8709",
  null
  
)

export default component.exports